/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { CustomerPickupTimeFragment } from './cartPickupTimeFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartRemovePickupTimeMutationVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
}>

export type CartRemovePickupTimeMutation = {
  __typename: 'Root'
  cartRemovePickupTime: {
    __typename: 'CartRemovePickupTimePayload'
    cart: {
      __typename: 'Cart'
      id: number | null
      delayedPickupAt: any | null
      pickupTimeSelected: boolean
    } | null
    errors: Array<{
      __typename: 'UserError'
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CartRemovePickupTimeMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CartRemovePickupTimeMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartRemovePickupTime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'customerPickupTimeFragment'
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    ...CustomerPickupTimeFragment.definitions
  ]
} as unknown as DocumentNode
export type CartRemovePickupTimeMutationMutationFn = Apollo.MutationFunction<
  CartRemovePickupTimeMutation,
  CartRemovePickupTimeMutationVariables
>

/**
 * __useCartRemovePickupTimeMutation__
 *
 * To run a mutation, you first call `useCartRemovePickupTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartRemovePickupTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartRemovePickupTimeMutation, { data, loading, error }] = useCartRemovePickupTimeMutation({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *   },
 * });
 */
export function useCartRemovePickupTimeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartRemovePickupTimeMutation,
    CartRemovePickupTimeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CartRemovePickupTimeMutation,
    CartRemovePickupTimeMutationVariables
  >(CartRemovePickupTimeMutationDocument, options)
}
export type CartRemovePickupTimeMutationHookResult = ReturnType<
  typeof useCartRemovePickupTimeMutation
>
export type CartRemovePickupTimeMutationMutationResult =
  Apollo.MutationResult<CartRemovePickupTimeMutation>
export type CartRemovePickupTimeMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CartRemovePickupTimeMutation,
    CartRemovePickupTimeMutationVariables
  >
